import React from 'react';
import { useNavigate } from 'react-router';
import MagicButton from 'components/MagicButton/MagicButton';
import BadgeIcon from 'components/BadgeIcon/BadgeIcon';
import { MilestoneEarnedEvent } from 'types/interfaces/followingFeed';
import { FeedCardShell, profileHref } from './FeedCardShell';

interface MilestoneEarnedCardProps {
  event: MilestoneEarnedEvent;
}

export const MilestoneEarnedCard: React.FC<MilestoneEarnedCardProps> = ({
  event,
}) => {
  const { actor, payload } = event;
  const navigate = useNavigate();

  const hasBadgeIconFields =
    payload.badgeIcon && payload.badgeShape && payload.badgeTier;

  const hero = (
    <div className="feed-milestone-hero">
      {hasBadgeIconFields ? (
        <BadgeIcon
          icon={payload.badgeIcon!}
          shape={payload.badgeShape!}
          tier={payload.badgeTier!}
          size={96}
          earned
        />
      ) : payload.badgeIconUrl ? (
        <img
          src={payload.badgeIconUrl}
          alt={payload.badgeName}
          className="feed-milestone-fallback-img"
          width={80}
          height={80}
        />
      ) : (
        <div className="feed-milestone-fallback-img feed-milestone-fallback-img--placeholder" />
      )}
      <div className="feed-milestone-name">{payload.badgeName}</div>
      {payload.badgeDescription && (
        <div className="feed-milestone-desc">{payload.badgeDescription}</div>
      )}
    </div>
  );

  const footer = (
    <MagicButton
      label={`View ${actor.username}'s profile`}
      color="purple"
      onPress={() => navigate(profileHref(actor))}
    />
  );

  return (
    <FeedCardShell
      variant="milestone"
      actor={actor}
      actionText="earned a badge"
      createdAt={event.createdAt}
      hero={hero}
      footer={footer}
    />
  );
};

export default MilestoneEarnedCard;
